import { LitheDocsObject } from './types';

export default class LitheDocs {
  private _source: string;

  constructor(source: string) {
    if (!source.trim()) throw new Error('lithe-docs: no data to parse');
    this._source = source;
  }

  parse(): LitheDocsObject {
    const [frontmatter, content] = this._source.split('---');

    if (!frontmatter.trim() || !content.trim())
      throw new Error('invalid_docs_format');

    const result = frontmatter
      .split('\n')
      .filter((row) => row.trim())
      .reduce((acc, curr) => {
        const [key, value] = curr.split('=');

        if (!key.trim() || !value.trim())
          throw new Error('invalid_docs_content_format');

        acc[key] = value;

        return acc;
      }, {} as Record<string, string>);

    return { ...result, content: JSON.parse(content) };
  }
}
